import { render, staticRenderFns } from "./QRScanner.vue?vue&type=template&id=2e974bb0&scoped=true&"
import script from "./QRScanner.vue?vue&type=script&lang=js&"
export * from "./QRScanner.vue?vue&type=script&lang=js&"
import style0 from "./QRScanner.vue?vue&type=style&index=0&id=2e974bb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e974bb0",
  null
  
)

export default component.exports